import { FC } from 'react';
import styles from './MissionSection.module.scss';

import { Button } from 'components/parts/Button';
import { useNavigate } from 'react-router-dom';
import { Mission, SpotData } from 'types/spot';
import { areaDetailImages } from 'components/pages/AreaDetail/images';
import { ProgressResponse } from 'store/progress';
import { cx } from 'utils/cx';

function useLocalAssetImagePath(imageUrl: string | undefined) {
  if (!imageUrl) return null;
  const fileName = new URL(imageUrl).pathname.split('/').pop();
  if (!fileName) return null;
  try {
    return require(`components/pages/Area/images/${fileName.replace(/\.png$/, '.webp')}`) ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
}

const MissionStep: FC<{ mission: Mission; isFirstMission: boolean; isCompleted: boolean }> = ({
  mission,
  isFirstMission,
  isCompleted,
}) => {
  const nazoImagePath = useLocalAssetImagePath(mission.nazo.url);
  const navigate = useNavigate();

  return (
    <div className={styles.step}>
      <div
        id={`mission-${mission.missionNo}`}
        className={cx(
          styles.anchorLocationMarker,
          isFirstMission && styles.anchorLocationMarkerFirstMission
        )}
      />
      {isFirstMission && <img src={areaDetailImages.charaNormal} alt="" className={styles.chara} />}
      <div className={styles.stepInnerEdge}>
        <div className={styles.stepInner}>
          <h2 className={styles.stepHeading}>{mission.title.replace(/\\n/g, '\n')}</h2>
          <p className={styles.stepText}>
            下のミッションをクリアして手に入れたキーワードを報告しよう！
          </p>
          <div className={styles.nazo}>
            {nazoImagePath && <img src={nazoImagePath} alt="" className={styles.nazoImage} />}
          </div>
          <div className={styles.stepKeywordButton}>
            <Button
              text="キーワードを入力"
              styleType="primary"
              handleClick={() => navigate(`/mission/answer/${mission.missionNo}`)}
              addClass={[styles.spotButton]}
              disabled={isCompleted}
            />
          </div>
        </div>
      </div>
      {isCompleted && (
        <img
          src={areaDetailImages.missionBadgeComplete}
          alt="クリア"
          className={styles.missionBadgeComplete}
        />
      )}
    </div>
  );
};

export const MissionSection: FC<{
  article: SpotData;
  progressData: ProgressResponse | undefined;
}> = ({ article, progressData }) => {
  return (
    <div className={styles.body}>
      <div className={styles.missionHeader}>
        <img src={areaDetailImages.missionHeader} alt="ミッション" />
      </div>
      {article?.mission?.map((mission, index) => {
        const isCompleted =
          progressData?.missionStatusList.find(m => m.missionNo === mission.missionNo)?.completed ??
          false;
        return (
          <MissionStep
            key={mission.missionNo}
            mission={mission}
            isFirstMission={index === 0}
            isCompleted={isCompleted}
          />
        );
      })}
    </div>
  );
};
